import React from 'react';
import { components } from 'react-select';

import MainCheckBox from '../checkbox/Checkbox';

const Option = (props: any) => {
  const { isSelected, label } = props;

  return (
    <components.Option {...props}>
      <MainCheckBox className="filter-checkbox" checked={isSelected} />
      <label>{label}</label>
    </components.Option>
  );
};

export default Option;
